import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { UpdateAssetBrandVoicePopup } from './UpdateAssetBrandVoicePopup';

export const UPDATE_ASSET_BRAND_VOICE_POPUP = Symbol('UPDATE_ASSET_BRAND_VOICE');

export const useUpdateAssetBrandVoicePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(UPDATE_ASSET_BRAND_VOICE_POPUP, UpdateAssetBrandVoicePopup);
  });

  return useCallback(
    ({ asset, language, onSave }) => {
      popups.openPopup(UPDATE_ASSET_BRAND_VOICE_POPUP, {
        asset,
        language,
        onSave,
      });
    },
    [popups]
  );
};
